import CloseIcon from "@mui/icons-material/CloseRounded";
import { Typography } from "@mui/material";
import type { PropsWithChildren } from "react";
import PopoverMenuItem from "@entrilia/shared/components/PopoverMenuItem";

interface Props {
  disabled?: boolean;
  onRemove: () => void;
}
export default function FieldOptionDeleteButton({ disabled, onRemove, children }: PropsWithChildren<Props>) {
  return (
    <PopoverMenuItem
      sx={(theme) => ({
        justifyContent: "center",
        gap: 1,
        bgcolor: theme.palette.background.grey,
        borderBottomLeftRadius: theme.spacing(0.5),
        borderBottomRightRadius: theme.spacing(0.5),
        color: theme.palette.error.main,
        height: theme.spacing(4.5),
        flex: "0 0 auto",
      })}
      disabled={disabled}
      onClick={onRemove}
    >
      <CloseIcon sx={(theme) => ({ fontSize: theme.spacing(2) })} />
      <Typography sx={{ fontWeight: 500 }}>{children ?? "Remove Field"}</Typography>
    </PopoverMenuItem>
  );
}
